import { Box, ErrorMessage, Label, RequiredAsterisk, Textfield } from '@forge/react';
import React from 'react';
import { DateTimePicker } from './components/DateTimePicker';
import { DurationPicker } from './components/DurationPicker';
import { isStartAfterEnd } from './shared';
export function BookingForm(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { state, dispatch, hideSummary, renderResource, fields } = props;
    const { startDate, endDate, duration, summary } = state;
    const fieldsToUse = fields || {};
    const endBeforeStart = isStartAfterEnd(state);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { paddingBlockEnd: 'space.100' },
            React.createElement(Label, { labelFor: 'localStartDate' }, (_b = (_a = fieldsToUse.startDate) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : 'Start Date',
                " ",
                React.createElement(RequiredAsterisk, null)),
            React.createElement(DateTimePicker, { id: 'localStartDate', value: startDate, onChange: (startDate) => dispatch({
                    type: 'update-start',
                    payload: {
                        startDate
                    }
                }) })),
        React.createElement(Box, { paddingBlockEnd: 'space.100' },
            React.createElement(Label, { labelFor: 'duration' }, (_d = (_c = fieldsToUse.duration) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : 'Duration'),
            React.createElement(DurationPicker, { id: 'duration', value: duration, onChange: (duration) => dispatch({
                    type: 'update-duration',
                    payload: {
                        ...duration
                    }
                }) })),
        React.createElement(Box, { paddingBlockEnd: 'space.100' },
            React.createElement(Label, { labelFor: 'localEndDate' }, (_f = (_e = fieldsToUse.endDate) === null || _e === void 0 ? void 0 : _e.label) !== null && _f !== void 0 ? _f : 'End Date',
                " ",
                React.createElement(RequiredAsterisk, null)),
            React.createElement(DateTimePicker, { id: 'localEndDate', value: endDate, onChange: (endDate) => dispatch({
                    type: 'update-end',
                    payload: {
                        endDate
                    }
                }) }),
            endBeforeStart && React.createElement(ErrorMessage, null, "End date must be after Start date")),
        React.createElement(Box, { paddingBlockEnd: 'space.100' },
            React.createElement(Label, { labelFor: 'resource' }, (_h = (_g = fieldsToUse.resource) === null || _g === void 0 ? void 0 : _g.label) !== null && _h !== void 0 ? _h : 'Resource',
                " ",
                React.createElement(RequiredAsterisk, null)),
            React.createElement(Box, null, renderResource())),
        !hideSummary && (React.createElement(Box, { paddingBlockEnd: 'space.100' },
            React.createElement(Label, { labelFor: 'summary' }, (_k = (_j = fieldsToUse.summary) === null || _j === void 0 ? void 0 : _j.label) !== null && _k !== void 0 ? _k : 'Summary',
                " ",
                React.createElement(RequiredAsterisk, null)),
            React.createElement(Textfield, { id: 'summary', value: summary, onChange: (event) => dispatch({
                    type: 'update-summary',
                    payload: {
                        value: event.target.value
                    }
                }) })))));
}
